import FaqInner from './FaqInner'

export default FaqInner
